import React from "react";
import ReactDOM from "react-dom";
import NewsIndex from "./newsIndex";
import NewsDeputy from "./newsDeputy";
import qs from "qs";

const params = qs.parse(location.search, { ignoreQueryPrefix: true });

console.log(params);

const $app = document.getElementById("app");
$app && ReactDOM.render(!params?.t ? <NewsIndex /> : <NewsDeputy />, $app);
